<template>
  <section class="landing-page">
    <Header />
    <MainInfo currentCard="Color Palette" />
    <Pricing />
    <ProductHunt />
    <Footer />

    <section class="hunt"></section>

    <footer class="footer"></footer>
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import MainInfo from "@/components/comparison/MainInfo";
import Pricing from "@/components/landing/Pricing";
import ProductHunt from "@/components/landing/ProductHunt";
import Footer from "@/components/landing/Footer";
import { updateMetaTag, updateCanonical } from '@/utils/useHeadUtils';

export default {
  components: {
    Header,
    MainInfo,
    Pricing,
    ProductHunt,
    Footer,
  },
  mounted() {
    const title = 'Site Palette vs. Color Palette: Why Designers Choose Site Palette for Advanced Features';
    const description = 'Explore the differences between Site Palette and Color Palette, and understand why designers prefer Site Palette for its superior palette creation and export capabilities, tailored to enhance the design workflow.';

    document.title = title;
    updateMetaTag('description', description);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateCanonical('https://palette.site/vs-color');
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
